import { Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface ITitleProps {
  title: string;
  subtitle: string;
}

export const Title = (props: ITitleProps) => {
  const isDesktop = useIsDesktop();
  const { title, subtitle } = props;

  return (
    <>
      <Typography
        component='h1'
        variant='h2'
        m={isDesktop ? '40px 0 16px' : '13px 0 16px'}
        tabIndex={0}
      >
        {title}
      </Typography>
      <Typography component='h2' variant='body3' m='0'>
        {subtitle}
      </Typography>
    </>
  );
};
